class ProductMediaGallery extends HTMLElement {
  constructor() {
    super()
    this.gallery = this.querySelector('[data-gallery-main]')
    this.thumbs = this.querySelector('[data-gallery-thumbs]')
    this.id = this.dataset.sectionId

    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        const ref = this.thumbs.querySelector(
          `[data-media-id="${entry.target.dataset.mediaId}"`
        )
        if (entry.isIntersecting) {
          ref.classList.add('border-cotton')
          this.thumbs.scrollTo({
            top: 0,
            left: ref.offsetLeft,
            behavior: 'smooth',
          })
        } else {
          ref.classList.remove('border-cotton')
        }
      })
    }
    let options = {
      root: null,
      rootMargin: '4000px 0px 4000px 0px',
      threshold: 0.6,
    }
    this.thumbObserver = new IntersectionObserver(callback, options)

    this.init()
  }
  init() {
    this.thumbs.querySelectorAll('button').forEach((thumb) => {
      const mainGalleryItem = this.querySelector(`#${thumb.dataset.refId}`)
      thumb.addEventListener('click', () => {
        this.gallery.scrollTo({
          top: 0,
          left: mainGalleryItem.offsetLeft,
          behavior: 'smooth',
        })
      })
    })
    this.gallery.querySelectorAll('li').forEach((item) => {
      this.thumbObserver.observe(item)
    })
    this.setUpVariantListener()
  }
  setUpVariantListener() {
    const sectionId = document.querySelector('product-media-gallery').dataset
      .sectionId
    document.addEventListener('DOMContentLoaded', function () {
      const variantSwitcher = document.querySelector(
        `variant-radios[data-section="${sectionId}"], sibling-variant-radios[data-section="${sectionId}"]`
      )

      if (!variantSwitcher) {
        console.warn(`No variant switcher found for section ${sectionId}`)
        return
      }
    })

    // This function listens for changes to the "data-option-for-variant-media" which defaults to the "color" option. When that option changes, product media whose alt text does not include the color value is hidden. The exception is any product media whose alt text includes the keyword "all"
    if (!this.dataset.showOnlyVariantMedia) {
      return
    }
    this.OPTION_FOR_IMAGES = this.getAttribute('data-option-for-variant-media')
      ? `option${this.getAttribute(`data-option-for-variant-media`)}`
      : 'option1'
    this.option_value = this.getAttribute(
      `data-starting-${this.OPTION_FOR_IMAGES}`
    )?.toLowerCase()
    const variantSwitcher = document.querySelector(
      `variant-radios[data-section="${this.dataset.sectionId}"], sibling-variant-radios[data-section="${this.dataset.sectionId}"]`
    )

    if (!variantSwitcher) {
      console.warn(
        `No variant switcher found for section ${this.dataset.sectionId}`
      )
      return
    }
    const showHideMedia = (currentVariant) => {
      if (!currentVariant.featured_media) {
        return false
      }
      this.querySelectorAll('[data-variant-alt]').forEach((media) => {
        let alt = media.dataset.variantAlt.toLowerCase()
        const [variantTitle, variantColor] = alt
          .split('|')
          .map((str) => str.trim())
        if (variantColor == this.option_value || alt.includes('| all')) {
          media.classList.remove('hidden')
        } else if (currentVariant) {
          let variant_media_id = media.dataset.mediaId
          let current_featured = currentVariant.featured_media
            ? `${this.dataset.sectionId}-${currentVariant.featured_media.id}`
            : 0
          if (current_featured == variant_media_id) {
            media.classList.remove('hidden')
          } else {
            media.classList.add('hidden')
          }
        } else {
          media.classList.add('hidden')
        }
      })
    }
    if (this.option_value) {
      // Only call these methods if they exist (variant-radios has them, sibling-variant-radios doesn't)
      if (typeof variantSwitcher.updateOptions === 'function') {
        variantSwitcher.updateOptions()
      }
      if (typeof variantSwitcher.updateMasterId === 'function') {
        variantSwitcher.updateMasterId()
      }
      if (variantSwitcher.currentVariant) {
        showHideMedia(variantSwitcher.currentVariant)
      }
    }
    variantSwitcher.addEventListener('change', () => {
      if (!variantSwitcher) {
        return
      }

      // Check if currentVariant exists and has the required option
      if (
        variantSwitcher.currentVariant &&
        variantSwitcher.currentVariant[this.OPTION_FOR_IMAGES]
      ) {
        let newValue =
          variantSwitcher.currentVariant[this.OPTION_FOR_IMAGES].toLowerCase()
        if (newValue === this.option_value) {
          return
        }
        this.option_value = newValue
        showHideMedia(variantSwitcher.currentVariant)
      }
    })
  }
}

customElements.define('product-media-gallery', ProductMediaGallery)
